<template>
  <table class="table">
    <template v-if="isEndorsement">
      <tr class="tr th">
        <th>Field</th>
        <th
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">Driver {{ index+1 }}</th>
      </tr>
      <tr class="tr">
        <td>Relationship with Policyholder</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <!--        {{ item.nm_drvr_rel_language }}-->
          <span
            v-if="compareChange(index,'nm_drvr_rel')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ getLocalAllOptionName('relation', preFormData.nm_drvr_list[index].nm_drvr_rel) }}</span>
            <span class="green-tip">{{ getLocalAllOptionName('relation', item.nm_drvr_rel) }}</span>
          </span>
          <span
            v-else
            v-copy="getLocalAllOptionName('relation', item.nm_drvr_rel)">
            {{ getLocalAllOptionName('relation', item.nm_drvr_rel) }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>Title</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_title')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ getOptionName('titleOptions', preFormData.nm_drvr_list[index].nm_drvr_title) }}</span>
            <span class="green-tip">{{ getOptionName('titleOptions', item.nm_drvr_title) }}</span>
          </span>
          <span
            v-else
            v-copy="getOptionName('titleOptions', item.nm_drvr_title)">
            {{ getOptionName('titleOptions', item.nm_drvr_title) }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>Last Name</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_lst_nm')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{preFormData.nm_drvr_list[index].nm_drvr_lst_nm}}</span>
            <span class="green-tip">{{ item.nm_drvr_lst_nm }}</span>
          </span>
          <span
            v-else
            v-copy="item.nm_drvr_lst_nm">
            {{ item.nm_drvr_lst_nm }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>First Name</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_fst_nm')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ preFormData.nm_drvr_list[index].nm_drvr_fst_nm}}</span>
            <span class="green-tip">{{ item.nm_drvr_fst_nm }}</span>
          </span>
          <span v-else>
            {{ item.nm_drvr_fst_nm }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>Date of Birth</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_dob_date')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ preFormData.nm_drvr_list[index].nm_drvr_dob_date}}</span>
            <span class="green-tip">{{ item.nm_drvr_dob_date }}</span>
          </span>
          <span v-else>
            {{ item.nm_drvr_dob_date }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>HKID / Passport </td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_id_type')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ getOptionName('idTypeOptions', preFormData.nm_drvr_list[index].nm_drvr_id_type) }}</span>
            <span class="green-tip">{{ getOptionName('idTypeOptions', item.nm_drvr_id_type) }}</span>
          </span>
          <span v-else>
            {{ getOptionName('idTypeOptions', item.nm_drvr_id_type) }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>ID Number</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_id_no')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ preFormData.nm_drvr_list[index].nm_drvr_id_no}}</span>
            <span class="green-tip">{{ item.nm_drvr_id_no }}</span>
          </span>
          <span v-else>
            {{ item.nm_drvr_id_no }}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>Occupation</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_occ_id')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ getLocalAllOptionName('occupation', preFormData.nm_drvr_list[index].nm_drvr_occ_id) }}</span>
            <span class="green-tip">{{ getLocalAllOptionName('occupation', item.nm_drvr_occ_id) }}</span>
          </span>
          <span v-else>
            {{ item.nm_drvr_occ}}
          </span>
        </td>
      </tr>
      <tr class="tr">
        <td>Driving Experience</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <template v-if="classId == 14">
            <span
              v-if="compareChange(index,'nm_drvr_exp')"
              class="compare">
              <span
                v-if="preFormData.nm_drvr_list[index]"
                class="color-danger">{{ getLocalAllOptionName('dr_lic_of_own', preFormData.nm_drvr_list[index].nm_drvr_exp) }}</span>
              <span class="green-tip">{{ getLocalAllOptionName('dr_lic_of_own', item.nm_drvr_exp) }}</span>
            </span>
            <span v-else>
              {{ getLocalAllOptionName('dr_lic_of_own', item.nm_drvr_exp) }}
            </span>
          </template>
          <template v-else>
            <span
              v-if="compareChange(index,'nm_drvr_exp')"
              class="compare">
              <span
                v-if="preFormData.nm_drvr_list[index]"
                class="color-danger">{{ getLocalAllOptionName('drvr_exp', preFormData.nm_drvr_list[index].nm_drvr_exp) }}</span>
              <span class="green-tip">{{ getLocalAllOptionName('drvr_exp', item.nm_drvr_exp) }}</span>
            </span>
            <span v-else>
              {{ getLocalAllOptionName('drvr_exp', item.nm_drvr_exp) }}
            </span>
          </template>
        </td>
      </tr>
      <tr
        v-if="form.no_dr_acci_ind==0"
        class="tr">
        <td>Number of accident in last 3 years</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_acc')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ getAllOptionName('accident_num', preFormData.nm_drvr_list[index].nm_drvr_acc) }}</span>
            <span class="green-tip">{{ getAllOptionName('accident_num', item.nm_drvr_acc) }}</span>
          </span>
          <span v-else>
            {{ getAllOptionName('accident_num', item.nm_drvr_acc) }}
          </span>
        </td>
      </tr>
      <tr
        v-if="form.no_dr_deduct_ind==0"
        class="tr">
        <td>Number of driving offence point in last 3 years</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">
          <span
            v-if="compareChange(index,'nm_drvr_pt')"
            class="compare">
            <span
              v-if="preFormData.nm_drvr_list[index]"
              class="color-danger">{{ getAllOptionName('off_points', preFormData.nm_drvr_list[index].nm_drvr_pt) }}</span>
            <span class="green-tip">{{ getAllOptionName('off_points', item.nm_drvr_pt) }}</span>
          </span>
          <span v-else>
            {{ getAllOptionName('off_points', item.nm_drvr_pt) }}
          </span>
        </td>
      </tr>
    </template>
    <template v-else>
      <tr class="tr th">
        <td>Field</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index">Driver {{ index+1 }}</td>
      </tr>
      <tr class="tr">
        <td>Relationship with Policyholder</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="getLocalAllOptionName('relation', item.nm_drvr_rel)"
          :class="{'green-tip':compareChange(index,'nm_drvr_rel')}">
          <!--        {{ item.nm_drvr_rel_language }}-->
          {{ getLocalAllOptionName('relation', item.nm_drvr_rel) }}
        </td>
      </tr>
      <tr class="tr">
        <td>Title</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="getOptionName('titleOptions', item.nm_drvr_title)"
          :class="{'green-tip':compareChange(index,'nm_drvr_title')}">
          {{ getOptionName('titleOptions', item.nm_drvr_title) }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_title'+index"-->
          <!--            :text="getOptionName('titleOptions', item.nm_drvr_title)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>Last Name</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="item.nm_drvr_lst_nm"
          :class="{'green-tip':compareChange(index,'nm_drvr_lst_nm')}">
          {{ item.nm_drvr_lst_nm }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_lst_nm'+index"-->
          <!--            :text="item.nm_drvr_lst_nm"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>First Name</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="item.nm_drvr_fst_nm"
          :class="{'green-tip':compareChange(index,'nm_drvr_fst_nm')}">
          {{ item.nm_drvr_fst_nm }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_fst_nm'+index"-->
          <!--            :text="item.nm_drvr_fst_nm"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>Date of Birth</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="item.nm_drvr_dob_date"
          :class="{'green-tip':compareChange(index,'nm_drvr_dob_date')}">
          {{ item.nm_drvr_dob_date }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_dob_date'+index"-->
          <!--            :text="item.nm_drvr_dob_date"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>HKID / Passport </td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="getOptionName('idTypeOptions', item.nm_drvr_id_type)"
          :class="{'green-tip':compareChange(index,'nm_drvr_id_type')}">
          {{ getOptionName('idTypeOptions', item.nm_drvr_id_type) }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_id_type'+index"-->
          <!--            :text="getOptionName('idTypeOptions', item.nm_drvr_id_type)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>ID Number</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="item.nm_drvr_id_no"
          :class="{'green-tip':compareChange(index,'nm_drvr_id_no')}">
          {{ item.nm_drvr_id_no }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_id_no'+index"-->
          <!--            :text="item.nm_drvr_id_no"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>Occupation</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="item.nm_drvr_occ"
          :class="{'green-tip':compareChange(index,'nm_drvr_occ')}">
          {{ item.nm_drvr_occ}}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_occ_id'+index"-->
          <!--            :text="getLocalAllOptionName('occupation', item.nm_drvr_occ_id)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr class="tr">
        <td>Driving Experience</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy=" classId == 14?
            getLocalAllOptionName('dr_lic_of_own', item.nm_drvr_exp):
            getLocalAllOptionName('drvr_exp', item.nm_drvr_exp)"
          :class="{'green-tip':compareChange(index,'nm_drvr_exp')}">
          {{
            classId == 14?
              getLocalAllOptionName('dr_lic_of_own', item.nm_drvr_exp):
              getLocalAllOptionName('drvr_exp', item.nm_drvr_exp)
          }} -
          <!--          <alt-copy-->
          <!--            v-if="classId == 14"-->
          <!--            :key_value="'dr_lic_of_own'+index"-->
          <!--            :text="getLocalAllOptionName('dr_lic_of_own', item.nm_drvr_exp)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
          <!--          <alt-copy-->
          <!--            v-else-->
          <!--            :key_value="'nm_drvr_exp'+index"-->
          <!--            :text="getLocalAllOptionName('drvr_exp', item.nm_drvr_exp)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
          <!-- {{ getLocalAllOptionName('drvr_exp', item.nm_drvr_exp) }} -->
        </td>
      </tr>
      <tr
        v-if="form.no_dr_acci_ind==0"
        class="tr">
        <td>Number of accident in last 3 years</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="getAllOptionName('accident_num', item.nm_drvr_acc)"
          :class="{'green-tip':compareChange(index,'nm_drvr_acc')}">
          {{ getAllOptionName('accident_num', item.nm_drvr_acc) }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_acc'+index"-->
          <!--            :text="getAllOptionName('accident_num', item.nm_drvr_acc)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
      <tr
        v-if="form.no_dr_deduct_ind==0"
        class="tr">
        <td>Number of driving offence point in last 3 years</td>
        <td
          v-for="(item, index) in form.nm_drvr_list"
          :key="index"
          v-copy="getAllOptionName('off_points', item.nm_drvr_pt)"
          :class="{'green-tip':compareChange(index,'nm_drvr_pt')}">
          {{ getAllOptionName('off_points', item.nm_drvr_pt) }}
          <!--          <alt-copy-->
          <!--            :key_value="'nm_drvr_pt'+index"-->
          <!--            :text="getAllOptionName('off_points', item.nm_drvr_pt)"-->
          <!--            :copyKey="copyKey"-->
          <!--            className="key-alt-down"-->
          <!--            @sendKey="getKey"></alt-copy>-->
        </td>
      </tr>
    </template>
  </table>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'InsuredVehicleInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      copyKey: ''
    }
  },
  computed: {
    classId() {
      return this.form.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    compareChange(){
      return (index,name)=>{
        let {nm_drvr_list,type} = this.form||{}
        let pre = this.preFormData||{}
        let preList =pre.nm_drvr_list||[]
        if(this.isEndorsement){
          if(preList[index]){
            return nm_drvr_list[index][name]!=preList[index][name]||false
          }
          return true
        }else{
          if(type!=50)return  false
          if(preList.length<=0)return false
          return nm_drvr_list[index][name]!=preList[index][name]||false
        }
      }
    }
  },
  watch: {
    'form.nm_drvr_list': {
      immediate: true,
      deep: true,
      handler(list) {
        if(list) {
          this.$emit('open-driver', list)
        }
      }
    }
  },
  methods: {
    openFile(url, check = true) {
      if(!url || !check) {
        return
      }
      window.open(url, '_blank')
    },
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    getKey(key){
      this.copyKey = key
    },
  }
}
</script>
<style lang="scss" scoped>
.compare {
  display: flex;
  align-items: center;
  .color-danger{
    text-decoration: line-through;
  }
  & > span {
    flex: 1;
  }
}
</style>
